import React from "react";
import {GetDeliveredPrescriptionResponseType} from "../../../../types/ihioPrescriptionFilling";


type OrderPartnerInfoProps = {
    deliveredPrescriptionData: GetDeliveredPrescriptionResponseType | null;
}

const OrderPartnerInfo = ({
    deliveredPrescriptionData,
}: OrderPartnerInfoProps) => {

    return(
        <>
            <div className={'w-100 rounded rounded-4 border border-info bg-white mt-8 py-3 px-4'}>
                <div className="row row-cols-lg-5 row-cols-md-3 row-cols-2 mt-3">
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            نام شریک کاری:
                        </span>
                        <span className={'text-gray2'}>
                            {deliveredPrescriptionData?.orderPartnerInfo?.partnerName}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            نام همکار:
                        </span>
                        <span className={'text-gray2'}>
                            {deliveredPrescriptionData?.orderPartnerInfo?.contractPartyName}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            تخصص:
                        </span>
                        <span className={'text-gray2'}>
                            {deliveredPrescriptionData?.orderPartnerInfo?.licenseName}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            کد نظام پزشکی:
                        </span>
                        <span className={'text-gray2'}>
                            {deliveredPrescriptionData?.orderPartnerInfo?.noMedicalSystem || 0}
                        </span>
                    </div>
                    <div className={'d-flex align-items-center mb-3'}>
                        <span className={'text-gray ms-3'}>
                            شماره تماس:
                        </span>
                        <span className={'text-gray2'}>
                            {deliveredPrescriptionData?.orderPartnerInfo?.partnerPhone || ''}
                        </span>
                    </div>
                </div>

            </div>
        </>
    )
}


export default OrderPartnerInfo;